/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstituteLightResponse
 */
export interface InstituteLightResponse {
    /**
     * the unique identifier of the institute
     * @type {string}
     * @memberof InstituteLightResponse
     */
    id?: string;
    /**
     * the name of the institute
     * @type {string}
     * @memberof InstituteLightResponse
     */
    name?: string;
    /**
     * the role of the institute
     * @type {string}
     * @memberof InstituteLightResponse
     */
    instituteRole?: string;
    /**
     * the active status of the institute
     * @type {boolean}
     * @memberof InstituteLightResponse
     */
    active?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof InstituteLightResponse
     */
    admin?: Array<string>;
}

/**
 * Check if a given object implements the InstituteLightResponse interface.
 */
export function instanceOfInstituteLightResponse(value: object): value is InstituteLightResponse {
    return true;
}

export function InstituteLightResponseFromJSON(json: any): InstituteLightResponse {
    return InstituteLightResponseFromJSONTyped(json, false);
}

export function InstituteLightResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstituteLightResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'instituteRole': json['instituteRole'] == null ? undefined : json['instituteRole'],
        'active': json['active'] == null ? undefined : json['active'],
        'admin': json['admin'] == null ? undefined : json['admin'],
    };
}

export function InstituteLightResponseToJSON(json: any): InstituteLightResponse {
    return InstituteLightResponseToJSONTyped(json, false);
}

export function InstituteLightResponseToJSONTyped(value?: InstituteLightResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'instituteRole': value['instituteRole'],
        'active': value['active'],
        'admin': value['admin'],
    };
}

